import init from './init';

const httpClient = init();

export default httpClient;
